module.exports = __webpack_public_path__ + "bb861c8328b956b0168d8a099b075255.png";